import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

export default function HomePage() {
  return (
    <main className="flex min-h-[100dvh] items-center justify-center bg-gradient-to-b from-saffron-50 via-background to-background p-6">
      <Card className="w-full max-w-md border-saffron-100/80 shadow-none">
        <CardHeader className="space-y-2 text-center">
          <p className="text-[11px] font-semibold uppercase tracking-[0.12em] text-saffron-700">
            ISKCON Pune · BCEC
          </p>
          <CardTitle className="text-2xl font-semibold tracking-tight">
            Attendance
          </CardTitle>
          <CardDescription>Who are you signing in as?</CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-3">
          <Button asChild size="lg" className="h-12 text-base">
            <Link to="/me/login">I&apos;m a devotee</Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="h-12 text-base">
            <Link to="/admin/login">I&apos;m a coordinator</Link>
          </Button>
        </CardContent>
      </Card>
    </main>
  );
}
